<template>
  <div class="ProductService">
    <RouteHeadAndCrumbs
      :backgroundImg="backgroundImg"
      :breadcrumbsInfo="breadcrumbsInfo"
    />
    <div class="tabs-container">
      <el-tabs
        class="tabs-body"
        v-model="tabActiveName"
        :before-leave="changeTab"
      >
        <el-tab-pane label="伦伟服务" name="services">
          <div class="service-area1">
            <p class="area-title-text">伦伟实业</p>
            <p class="desc-text">
              伦伟一直致力于成为行业领先的IT服务企业。用责任心、技术、流程和规范，使我们的用户任何时间、
            </p>
            <p class="desc-text">
              任何地点都能及时得到伦伟专业IT服务支持，保障用户业务稳定、持续和增长
            </p>
            <el-row>
              <el-col :span="6">
                <div class="area-first-icon-container area-icons-container">
                  <img
                    class="common-img"
                    src="../assets/images/cup.png"
                    alt=""
                  />
                  <img
                    class="white-img"
                    src="../assets/images/cup-white.png"
                    alt=""
                  />
                </div>
                <p>专业</p>
              </el-col>
              <el-col :span="6">
                <div class="area-second-icon-container area-icons-container">
                  <img
                    class="common-img"
                    src="../assets/images/idea.png"
                    alt=""
                  />
                  <img
                    class="white-img"
                    src="../assets/images/idea-white.png"
                    alt=""
                  />
                </div>
                <p>创新</p>
              </el-col>
              <el-col :span="6">
                <div class="area-third-icon-container area-icons-container">
                  <img
                    class="common-img"
                    src="../assets/images/open.png"
                    alt=""
                  />
                  <img
                    class="white-img"
                    src="../assets/images/open-white.png"
                    alt=""
                  />
                </div>
                <p>开放</p>
              </el-col>
              <el-col :span="6">
                <div class="area-fourth-icon-container area-icons-container">
                  <img
                    class="common-img"
                    src="../assets/images/share.png"
                    alt=""
                  />
                  <img
                    class="white-img"
                    src="../assets/images/share-white.png"
                    alt=""
                  />
                </div>
                <p>分享</p>
              </el-col>
            </el-row>
          </div>
          <div class="service-area2">
            <div class="service-inner-container">
              <p class="area-title-text">伦伟服务</p>
              <p class="desc-text">伦伟为你制定合适的解决方案</p>
              <div class="product-service-area-info">
                <el-row class="product-service-row">
                  <template v-for="item in serverList">
                    <el-col :key="item.id" :span="6">
                      <router-link :to="`/product-services/service/${item.id}`">
                        <div class="one-service-card">
                          <div class="card-img-container">
                            <img :src="item.imgUrl" />
                          </div>
                          <div class="one-service-text-content">
                            <p class="one-service-card-title">
                              {{ item.title }}
                            </p>
                            <p class="one-service-card-main-text">
                              {{ item.description }}
                            </p>
                          </div>
                          <img class="one-card-icon" :src="item.iconUrl" />
                        </div>
                      </router-link>
                    </el-col>
                  </template>
                </el-row>
              </div>
            </div>
          </div>
          <div class="service-area3">
            <p class="area-title-text">服务方案</p>
            <p class="desc-text">伦伟为你制定合适的解决方案</p>
            <div class="plan-info-container">
              <el-row>
                <el-col :span="6">
                  <div class="one-plan-info-card">
                    <div class="middle-icon-container">
                      <img src="../assets/images/butler.png" alt="" />
                    </div>
                    <div class="plan-title-text">
                      <p>管家式服务</p>
                    </div>
                    <div class="plan-content-text">
                      <p>电话/远程支持</p>
                      <p>无限次数现场维护</p>
                      <p>按需巡检</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="one-plan-info-card">
                    <div class="middle-icon-container">
                      <img src="../assets/images/flag.png" alt="" />
                    </div>
                    <div class="plan-title-text">
                      <p>驻场式服务</p>
                    </div>
                    <div class="plan-content-text">
                      <p>安排外包人员</p>
                      <p>在客户方从事</p>
                      <p>IT服务工作</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="one-plan-info-card">
                    <div class="middle-icon-container">
                      <img src="../assets/images/warningLight.png" alt="" />
                    </div>
                    <div class="plan-title-text">
                      <p>紧急式现场服务</p>
                    </div>
                    <div class="plan-content-text">
                      <p>安排技术人员</p>
                      <p>前往客户现场</p>
                      <p>提供计次上门服务</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="one-plan-info-card">
                    <div class="middle-icon-container">
                      <img src="../assets/images/remote.png" alt="" />
                    </div>
                    <div class="plan-title-text">
                      <p>远程服务</p>
                    </div>
                    <div class="plan-content-text">
                      <p>伦伟呼叫中心</p>
                      <p>提供电话远程</p>
                      <p>技术支持服务</p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            class="service-area4"
            :style="
              `background:url(${advantageAreaBackgroundImg}) no-repeat;background-size:cover;`
            "
          >
            <div class="service-area-shade-container"></div>
            <div class="advantage-text-container">
              <div class="advantage-left-text">
                <div class="advantage-left-main-text">
                  <p class="area-title-text">伦伟的优势</p>
                  <p class="desc-text">伦伟一直致力于成为行业领先的IT服务企业</p>
                </div>
              </div>
              <div class="advantage-right-text">
                <div class="one-advantage-area">
                  <p class="one-advantage-title">优势一</p>
                  <p class="one-advantage-desc">行业技术优势突出，拥有信息领域一流资质</p>
                </div>
                <div class="one-advantage-area">
                  <p class="one-advantage-title">优势二</p>
                  <p class="one-advantage-desc">信誉品牌实力突出，拥有稳定合作一流伙伴</p>
                </div>
                <div class="one-advantage-area">
                  <p class="one-advantage-title">优势三</p>
                  <p class="one-advantage-desc">专业服务品质突出，拥有信息服务一流保障</p>
                </div>
                <div class="one-advantage-area">
                  <p class="one-advantage-title">优势四</p>
                  <p class="one-advantage-desc">专业的技术团队，完善的售后服务</p>
                </div>
              </div>
            </div>
          </div>
          <div class="service-area5">
            <p class="area-title-text">服务保障</p>
            <p class="desc-text">伦伟为你制定合适的解决方案</p>
            <div class="ensure-content-container">
              <div class="one-ensure-container">
                <div class="security-icon-container">
                  <img
                    class="security-img"
                    src="../assets/images/security.png"
                    alt=""
                  />
                  <img
                    class="security-white-img"
                    src="../assets/images/security-white.png"
                    alt=""
                  />
                </div>
                <p class="one-ensure-title">公司企业文化</p>
                <p class="one-ensure-content-text">
                  1.诚信、高效、优秀、创新。
                </p>
                <p class="one-ensure-content-text">
                  2.让用户的网络与数据更安全，帮助用户的业务云化成功，公司可持续发展，建设基业永久长青。
                </p>
              </div>
              <div class="one-ensure-container">
                <div class="security-icon-container">
                  <img
                    class="security-img"
                    src="../assets/images/security.png"
                    alt=""
                  />
                  <img
                    class="security-white-img"
                    src="../assets/images/security-white.png"
                    alt=""
                  />
                </div>
                <p class="one-ensure-title">服务经验保障</p>
                <p class="one-ensure-content-text">
                  1.伦伟有19年IT服务经验，为400多家企业提供专业的IT技术支持服务。
                </p>
                <p class="one-ensure-content-text">
                  2.伦伟在以下领域有超过10年的工作经验: Windows Server, Linux
                  Server, Exchange Server, IBM Notes Server, Cisco Network等.
                </p>
              </div>
              <div class="one-ensure-container">
                <div class="security-icon-container">
                  <img
                    class="security-img"
                    src="../assets/images/security.png"
                    alt=""
                  />
                  <img
                    class="security-white-img"
                    src="../assets/images/security-white.png"
                    alt=""
                  />
                </div>
                <p class="one-ensure-title">安全性保障</p>
                <p class="one-ensure-content-text">
                  1.签订客户保密协议，100%保障客户信息安全。
                </p>
              </div>
              <div class="one-ensure-container">
                <div class="security-icon-container">
                  <img
                    class="security-img"
                    src="../assets/images/security.png"
                    alt=""
                  />
                  <img
                    class="security-white-img"
                    src="../assets/images/security-white.png"
                    alt=""
                  />
                </div>
                <p class="one-ensure-title">项目流程保障</p>
                <p class="one-ensure-content-text">
                  1.合同签订后如服务不满意，可提前一个月书面终止服务；余款停付，已付款未服务部分退回客户。
                </p>
                <p class="one-ensure-content-text">
                  2.不随意更换客户指定技术人员，对技术人员技术不符合要求的，客户可要求更换。
                </p>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="伦伟产品" name="products">
          <div class="products-container">
            <div class="products-left-menu-container">
              <div
                v-for="item in productTypeList"
                :key="item.value"
                @click="changeProductType(item.value)"
                :class="getProductTypeClass(item.value)"
              >
                <span>{{ item.label }}</span>
              </div>
            </div>
            <div class="products-main-info-container">
              <template v-for="item in productList">
                <div :key="item.id" class="one-product-info-container">
                  <p>{{ item.groupName }}</p>
                  <el-row>
                    <template v-for="childItem in item.children">
                      <el-col :key="childItem.id" :span="6">
                        <router-link
                          :to="`/product-services/product/${childItem.id}`"
                        >
                          <span>{{ childItem.name }}</span>
                        </router-link>
                      </el-col>
                    </template>
                  </el-row>
                </div>
              </template>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import cityImg from "../assets/images/66.png";

import advantageBgImg from "../assets/images/5990790.jpg";

import { SERVICES, ROUTEINFO, PRODUCTTYPELIST } from "../utils/constant";

import { GETPRODUCTLIST, GETSERVERLIST } from "../utils/uriList";

import { getUniqueId } from "../utils/utils";

export default {
  mounted() {
    this.getProductList();
    this.GETSERVERLIST();
  },
  data() {
    return {
      productTypeList: PRODUCTTYPELIST,
      backgroundImg: cityImg,
      breadcrumbsInfo: [
        {
          routeName: ROUTEINFO.home.name,
          routeLabel: "首页",
          routeTo: {
            path: ROUTEINFO.home.path,
          },
        },
        {
          routeName: ROUTEINFO.productService.name,
          routeLabel: "产品与服务",
        },
        {
          routeName: "runwel-service",
          routeLabel: "伦伟服务",
        },
      ],
      tabActiveName: SERVICES,
      advantageAreaBackgroundImg: advantageBgImg,
      productList: [],
      productTypeActiveValue: 0,
      serverList: [],
    };
  },
  methods: {
    async getProductList() {
      const response = await this.$http.get(GETPRODUCTLIST, {
        params: {
          type: this.productTypeActiveValue,
        },
      });
      if (response.data.code === 0) {
        this.formatData(response.data.data);
      }
    },
    async GETSERVERLIST() {
      const response = await this.$http.get(GETSERVERLIST, {
        params: {
          approvalStatus: 0,
        },
      });
      if (response.data.code === 0) {
        this.serverList = response.data.data.content;
      }
    },
    formatData(dataList) {
      const productList = [];
      const groupSet = new Set();
      for (let oneData of dataList) {
        groupSet.add(oneData.title);
      }
      const groupNameList = [...groupSet];
      for (let oneGroupName of groupNameList) {
        const oneGroupProductList = dataList.filter(
          (s) => s.title === oneGroupName
        );
        productList.push({
          id: getUniqueId(),
          groupName: oneGroupName,
          children: oneGroupProductList,
        });
      }
      this.productList = productList;
    },
    getProductTypeClass(value) {
      let className = "one-left-menu-item";
      if (this.productTypeActiveValue === value) {
        className += " is-active";
      }
      return className;
    },
    changeProductType(value) {
      this.productTypeActiveValue = value;
      this.getProductList();
    },
    changeTab(activeName) {
      console.log("activeName", activeName);
      this.tabActiveName = activeName;
      const tempBreadcrumbsInfo = [...this.breadcrumbsInfo];
      if (activeName === SERVICES) {
        tempBreadcrumbsInfo[2].routeLabel = "伦伟服务";
      } else {
        tempBreadcrumbsInfo[2].routeLabel = "伦伟产品";
      }
      this.breadcrumbsInfo = [...tempBreadcrumbsInfo];
    },
  },
};
</script>

<style lang="scss">
@import "../assets/scss/views/ProductService.scss";
</style>
